module.exports = __webpack_public_path__ + "static/media/sub-1.ac76901c.png";